import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Subheader.module.scss';

const Subheader = ({ title, center, elementType: Element, children }) => (
  <div className={cn(styles.subheader, { [styles.center]: center })}>
    <div className="container">
      {title && <Element>{title}</Element>}
      {children}
    </div>
  </div>
);

Subheader.propTypes = {
  title: PropTypes.string,
  center: PropTypes.bool,
  elementType: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
};

Subheader.defaultProps = {
  title: null,
  center: false,
  elementType: 'h3',
};

export default Subheader;
